import React from "react";
import {IIconGeneralPropsWithRotation} from "modules/types";
import styled from "@emotion/styled";

const SVG = styled.svg`
	transition: 0.25s;
	&.right {
		transform: rotate(90deg);
	}
	&.bottom {
		transform: rotate(180deg);
	}
	&.left {
		transform: rotate(270deg);
	}
`;

export const IconArrow: React.FC<IIconGeneralPropsWithRotation> = ({
	width = 24,
	height = 24,
	color = "#FFFFFF",
	to = "top",
}) => {
	return (
		<SVG
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			className={to}>
			<path d="M7 14L12 9L17 14H7Z" fill={color} />
		</SVG>
	);
};
